import { render } from "./PlanComponent.vue?vue&type=template&id=ac3dc59a"
import script from "./PlanComponent.vue?vue&type=script&lang=js"
export * from "./PlanComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__